import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { Gateway } from 'src/app/models/gateways-models/gateway.model';

@Component({
  selector: 'app-payments-gateway-photo-editor-card',
  templateUrl: './payments-gateway-photo-editor-card.component.html',
  styleUrls: ['./payments-gateway-photo-editor-card.component.scss']
})
export class PaymentsGatewayPhotoEditorCardComponent implements OnInit {

  @Input() gateway: Gateway;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private paymentsService: PaymentsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateImageGateway(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('gateway-image-spinner');
    this.paymentsService.updateGatewayImage(this.gateway.InternalId, imageUrl).subscribe(
      (res) => {
        this.paymentsService.refreshGateway();
        this.showSpinner = false;
        this.spinnerService.hide('gateway-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.paymentsService.refreshGateway();
        this.showSpinner = false;
        this.spinnerService.hide('gateway-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('gateway-image-spinner');
    this.paymentsService.updateGatewayImage(this.gateway.InternalId, null).subscribe(
      (res) => {
        this.paymentsService.refreshGateway();
        this.showSpinner = false;
        this.spinnerService.hide('gateway-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.paymentsService.refreshGateways();
        this.showSpinner = false;
        this.spinnerService.hide('gateways-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.gateway.Image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 250, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImageGateway(result[0].Url);
        }

      }
    );
  }
}
